module.exports = __webpack_public_path__ + "static/Dental implants smile after-26ad29cb180ba5f62e5a118e3db491aa.jpg";